/* eslint-disable @typescript-eslint/no-unused-expressions */
import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, OnInit } from '@angular/core';

import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { AppUtilityService } from 'src/app/app-utility.service';
import { ClientShowModel } from 'src/app/core/models/client-show.model';
import { LoanDocModel } from 'src/app/core/models/loanDoc.model';
import { ClientDetailsService } from 'src/app/core/rest-services/client-details.service';
import { QuoteStoreService } from 'src/app/core/rest-services/quote-store.service';
import { LMSDialogHandlerService } from 'src/app/shared/lmsdialog-handler.service';
import { LmsModalFrameComponent } from '@lmsSharedUI';
import { MdbButtonModule, MdbIconModule, MdbModalRef } from 'src/lib/mdb5-adapted/public-api';

import { FinbondFileModel } from '@lmsModels';
import { LmsTableWrapperComponent } from '@lmsShared';

import { ClientHeaderComponent } from '../client-header/client-header.component';

@Component({
  selector: 'app-client-documents',
  templateUrl: './client-documents.component.html',
  styleUrls: ['./client-documents.component.scss'],
  imports: [
    CommonModule,
    MdbButtonModule,
    MdbIconModule,
    LmsModalFrameComponent,
    ClientHeaderComponent,
    NgxPaginationModule,
    LmsTableWrapperComponent,
    //LMSSharedUiModule
  ],
  standalone: true,
})
export class ClientDocumentsComponent implements OnInit, AfterViewInit {
  private lmsDialogHandler = inject(LMSDialogHandlerService);

  //PAGINATOR CODE
  config: PaginationInstance = {
    id: 'pager1',
    itemsPerPage: 10,
    currentPage: 1
  };

  lstDocuments: any[] = [];
  quoteId: string;
  loanRef: string;
  loanDoc: LoanDocModel = new LoanDocModel();
  curr: any;
  downloadObject: any = {};
  finalFileName: any;
  downloadResults: any = {};
  isReadOnly = false;
  canUploadLoanSummary = false;
  isDocumentLoading = false;
  clientShow: ClientShowModel;

  constructor(
    public quoteStoreService: QuoteStoreService,
    public global_utility: AppUtilityService,
    public dialogRef: MdbModalRef<ClientDocumentsComponent>,
    private clientDetailsService: ClientDetailsService,
  ) {}

  ngOnInit(): void {
    this.isDocumentLoading = true;
  }

  ngAfterViewInit(): void {
    this.isDocumentLoading = true;
    setTimeout(() => {
      this.listClientDocs();
    });

  }

  listClientDocs() {
    console.log('listClientDocs ' + this.quoteId);
    this.loanDoc.quoteId = `Q${this.quoteId}`;

    this.clientDetailsService.listClientDocs(this.loanDoc).subscribe({
      next: (res: any) => {
        this.canUploadLoanSummary = !(Array.from(res).some((ls:any) => ls.documentType == 'LOAN_SUMMARY_U'));
        this.lstDocuments = res;
        this.isDocumentLoading = false;
      },
    });
  }

  onDownloadPdf(data: any) {
    this.curr = JSON.stringify(data.fileName);
    this.finalFileName = (this.curr as string).split('"').join('');
    console.log('Curr ' + this.finalFileName);

    (this.downloadObject.fileName = this.finalFileName),
    (this.downloadObject.bucketName = ''),
    (this.downloadObject.userName = ''),
    (this.downloadObject.originalFileName = this.finalFileName);

    this.clientDetailsService.download(this.downloadObject)
      .subscribe({
        next:(res: any) => {
          if(!res.success && res.errorType !== 'SUCCESS') {
            this.global_utility.warning('Nothing downloaded','DOCUMENT_DOWNLOAD_ERROR');
            return;
          }
          if (res && res.errorType == 'DOCUMENT_DOWNLOAD_ERROR') {
            this.global_utility.handleError(res.message,'DOCUMENT_DOWNLOAD_ERROR');
            return;
          }

          this.downloadResults = res;
          const base64String = this.downloadResults.documentContent;

          this.openPdfViewer(
            base64String,
            this.downloadResults.originalFilename,
            this.downloadResults.contentType,
          );
        },
        error: (err) => {
          this.global_utility.error('Document download error: '+err,'DOCUMENT_DOWNLOAD_ERROR');
        }
      });
  }

  deleteDocument(doc: any) {
    this.global_utility.startLoading('Submitting document..');
    doc.quoteId = this.quoteStoreService.quoteWorkbook.id;
    doc.idNumber = this.quoteStoreService.quoteWorkbook.idNumber;
    doc.userName = this.global_utility.getGlobalData('userDisplay');

    if (doc.documentType !== 'LOAN_SUMMARY_U') {
      this.global_utility.error(
        `Document ${doc.documentType} cannot be deleted`,
        'Document list',
      );
    } else {
      this.isDocumentLoading = true;
      this.clientDetailsService.deleteDocument(doc).subscribe((res) => {
        if (res) {
          this.lstDocuments = res;
          setTimeout(() => {
            this.listClientDocs();
          });
        }
        this.global_utility.stopLoading();
      });
    }
  }

  openPdfViewer(base64String: any, fileName: string, contentType: string) {
    const source = `data:` + contentType + `;base64,` + `${base64String}`;
    const dlgHandler = this.lmsDialogHandler;
    this.lmsDialogHandler.openDocumentViewer(source, fileName);
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    const finbondFile = new FinbondFileModel();
    finbondFile.fileName = file.name;
    finbondFile.contentType = file.type;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (!reader.result) {

        this.global_utility.warning('Content of the selected file is invalid');
        return;
      }

      finbondFile.fileContents = (reader.result as string).split(',')[1];
      this.loanDoc.contentType = finbondFile.contentType;
      this.loanDoc.originalFileName = finbondFile.fileName;
      this.loanDoc.documentContents = finbondFile.fileContents;
    };
  }

  onDocumentSubmit() {
    if (!this.loanDoc.originalFileName || this.isReadOnly) {
      if(!this.loanDoc.originalFileName) {
        const docType = this.loanDoc.documentType.replace(/_/g, " ");
        this.global_utility.info(`Please select the Loan Summary you have scanned and saved on you pc`, 'Document list');
        return;
      }

      this.loanDoc.documentName = `${this.quoteId}_Loan Summary(unsigned).pdf`;
      this.loanDoc.docId = 0;
      this.loanDoc.documentType = 'LOAN_SUMMARY_U';
    }

    this.global_utility.startLoading('Submitting document.');
    this.isDocumentLoading = true;
    this.loanDoc.idNumber = this.quoteStoreService.quoteWorkbook.idNumber;
    this.loanDoc.customerId = this.quoteStoreService.quoteWorkbook.clientNumber;
    this.loanDoc.loanId = `Q${this.quoteStoreService.quoteWorkbook.id}`;
    this.loanDoc.userName = this.global_utility.getGlobalData('userDisplay');
    this.loanDoc.applicationId = this.quoteStoreService.quoteWorkbook.id;
    this.loanDoc.checkListId = this.loanDoc.docId ?? 0;

    this.clientDetailsService.uploadDocument(this.loanDoc).subscribe({
      next:(res) => {
        if (res) {
          this.lstDocuments = res;
          this.canUploadLoanSummary = !(Array.from(res).some((ls:any) => ls.documentType == 'LOAN_SUMMARY_U'));

          this.isDocumentLoading = false;
          this.global_utility.stopLoading();
          this.loanDoc = {} as LoanDocModel;
        }},
      error: (err)=>{
        this.global_utility.error('Document upload error: '+err,'Document Upload Error');
        this.isDocumentLoading = false;
        this.global_utility.stopLoading();
      }
    });
  }

  covertDate(date: any) {
    if (date != null) {

      let str = date;
      str = str.substring(0, 10);
      date = str;
      return date;
    } else {
      return date;
    }
  }

  close() {
    this.dialogRef.close();
  }
}
